import reduceReducers from "reduce-reducers";

import changesetsMainReducer from "./changesets";
import groupsMainReducer from "./groups";
import productsMainReducer from "./products";
import resourceTypesMainReducer from "./resource-types";
import resourcesMainReducer from "./resources";
import rolesMainReducer from "./roles";
import servicesMainReducer from "./services";
import usersMainReducer from "./users";
import createFetchReducerWithNamedType from "./utils";

export { default as policiesReducer } from "./policies";

const defaults = {
  loading: false,
  items: []
};

const productsDefaults = {
  ...defaults,
  current: undefined
};

const productsFetchReducer = createFetchReducerWithNamedType(
  "policies",
  "PRODUCTS",
  productsDefaults
);

export const productsReducer = reduceReducers(
  productsFetchReducer,
  productsMainReducer,
  productsDefaults
);

const servicesDefaults = {
  ...defaults,
  current: undefined,
  filterTerm: ""
};

const servicesFetchReducer = createFetchReducerWithNamedType(
  "policies",
  "SERVICES",
  servicesDefaults
);

export const servicesReducer = reduceReducers(
  servicesFetchReducer,
  servicesMainReducer,
  servicesDefaults
);

const resourcesDefaults = {
  ...defaults,
  current: undefined
};

const resourcesFetchReducer = createFetchReducerWithNamedType(
  "policies",
  "RESOURCES",
  resourcesDefaults
);

export const resourcesReducer = reduceReducers(
  resourcesFetchReducer,
  resourcesMainReducer,
  resourcesDefaults
);

const resourceTypesDefaults = {
  ...defaults,
  current: undefined
};

const resourceTypesFetchReducer = createFetchReducerWithNamedType(
  "policies",
  "RESOURCE_TYPES",
  defaults
);

export const resourceTypesReducer = reduceReducers(
  resourceTypesFetchReducer,
  resourceTypesMainReducer,
  resourceTypesDefaults
);

export const permissionsReducer = createFetchReducerWithNamedType(
  "policies",
  "PERMISSIONS",
  defaults
);
const rolesDefaults = {
  ...defaults,
  filterTerm: ""
};

const rolesFetchReducer = createFetchReducerWithNamedType(
  "policies",
  "ROLES",
  rolesDefaults
);

export const rolesReducer = reduceReducers(
  rolesFetchReducer,
  rolesMainReducer,
  rolesDefaults
);

const usersGroupsDefaults = {
  ...defaults,
  current: undefined,
  filterTerm: ""
};

const usersFetchReducer = createFetchReducerWithNamedType(
  "policies",
  "USERS",
  usersGroupsDefaults
);

export const usersReducer = reduceReducers(
  usersFetchReducer,
  usersMainReducer,
  usersGroupsDefaults
);

const groupsFetchReducer = createFetchReducerWithNamedType(
  "policies",
  "GROUPS",
  usersGroupsDefaults
);

export const groupsReducer = reduceReducers(
  groupsFetchReducer,
  groupsMainReducer,
  usersGroupsDefaults
);

const changesetsDefaults = {
  ...defaults
};

const changesetsFetchReducer = createFetchReducerWithNamedType(
  "policies",
  "CHANGESETS",
  changesetsDefaults
);

export const changesetsReducer = reduceReducers(
  changesetsFetchReducer,
  changesetsMainReducer,
  changesetsDefaults
);
